/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuperadminUserDto } from '../../models/superadmin-user-dto';
import { UpdateTagsDto } from '../../models/update-tags-dto';

export interface SuperadminControllerUpdateTags$Params {
  uuid: string;
      body: UpdateTagsDto
}

export function superadminControllerUpdateTags(http: HttpClient, rootUrl: string, params: SuperadminControllerUpdateTags$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminUserDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerUpdateTags.PATH, 'patch');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuperadminUserDto>;
    })
  );
}

superadminControllerUpdateTags.PATH = '/superadmin/users/{uuid}/tags';
